import { Provider } from '@angular/core';
import { ERROR_HANDLER_TOKEN } from '../tokens/errors.token';
import { ErrorHandlerConfig } from '../models/errors.models';
import { ErrorHandlerService } from '@errorHandler';

/**
 * Provides error handling configuration for the application.
 *
 * This function sets up the error handler service with the necessary configurations,
 * including the application error messages and other optional configurations.
 *
 * @param config ErrorHandlerConfig object containing app-specific error messages.
 * @returns An array of providers to configure the ErrorHandlerService and inject the error messages.
 */
export const provideErrorHandler = (config: ErrorHandlerConfig): Provider[] => {
  return [
    // Provide the application-specific error messages & debug mode as an injectable token
    {
      provide: ERROR_HANDLER_TOKEN, // Injection token for error handler
      useValue: config, // Dynamically set the app error messages & debug mode
    },

    // Optionally provide additional configuration for the ErrorHandlerService
    {
      provide: ErrorHandlerService,
      useClass: ErrorHandlerService,
    },
  ];
};
